import { useState } from 'react';
import { describeLoadFailure, jsonOrThrow } from '../apiJson';

export function ListingRequestForm() {
  const [websiteUrl, setWebsiteUrl] = useState('');
  const [businessName, setBusinessName] = useState('');
  const [businessDescription, setBusinessDescription] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [formError, setFormError] = useState(null);
  const [formSuccess, setFormSuccess] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setFormError(null);
    setFormSuccess(false);
    setSubmitting(true);
    try {
      const res = await fetch('/api/listing-request.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          websiteUrl,
          businessName,
          businessDescription,
          email,
          phone,
        }),
      });
      await jsonOrThrow(res);
      setFormSuccess(true);
      setWebsiteUrl('');
      setBusinessName('');
      setBusinessDescription('');
      setEmail('');
      setPhone('');
    } catch (err) {
      setFormError(describeLoadFailure(err));
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <>
      {formSuccess && (
        <p
          className="about-page__banner about-page__banner--success"
          role="status"
        >
          Thank you — we have received your request and will be in touch.
        </p>
      )}
      {formError !== null && (
        <p className="about-page__banner about-page__banner--error" role="alert">
          {formError}
        </p>
      )}

      <form className="about-page__form" onSubmit={handleSubmit} noValidate>
        <div className="about-page__field">
          <label htmlFor="listing-website">Website URL</label>
          <input
            id="listing-website"
            name="websiteUrl"
            type="url"
            inputMode="url"
            autoComplete="url"
            placeholder="https://yourshop.mt"
            value={websiteUrl}
            onChange={(e) => setWebsiteUrl(e.target.value)}
            required
            maxLength={2048}
          />
        </div>
        <div className="about-page__field">
          <label htmlFor="listing-business">Business name</label>
          <input
            id="listing-business"
            name="businessName"
            type="text"
            autoComplete="organization"
            placeholder="Your company or trading name"
            value={businessName}
            onChange={(e) => setBusinessName(e.target.value)}
            required
            maxLength={255}
          />
        </div>
        <div className="about-page__field about-page__field--full">
          <label htmlFor="listing-description">Describe your business</label>
          <textarea
            id="listing-description"
            name="businessDescription"
            rows={5}
            placeholder="What do you sell? Who is it for? Anything we should know about your site or catalogue."
            value={businessDescription}
            onChange={(e) => setBusinessDescription(e.target.value)}
            required
            maxLength={8000}
          />
        </div>
        <div className="about-page__field">
          <label htmlFor="listing-email">Email</label>
          <input
            id="listing-email"
            name="email"
            type="email"
            autoComplete="email"
            placeholder="you@yourshop.mt"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            maxLength={255}
          />
        </div>
        <div className="about-page__field">
          <label htmlFor="listing-phone">Phone number</label>
          <input
            id="listing-phone"
            name="phone"
            type="tel"
            autoComplete="tel"
            placeholder="+356 …"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            required
            maxLength={64}
          />
        </div>
        <div className="about-page__actions">
          <button
            type="submit"
            className="about-page__submit"
            disabled={submitting}
          >
            {submitting ? 'Sending…' : 'Submit application'}
          </button>
        </div>
      </form>
    </>
  );
}
